export default ["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  // Now set up the states
  $stateProvider
    .state("rolesEdit", {
      parent: "app",
      url: "/roles/:id",
      feature: "menu.settings.roles",
      executeUserCheck: function canEditUsers(user) {
        return user.effectiveUserObjectPermissions && user.effectiveUserObjectPermissions.userObjectsEdit;
      },
      views: {
        "main": {
          template: require("./eaRoleDetailPage/eaRoleDetailPageModule.html"),
          controller: "eaRoleDetailPageModuleController as $ctrl"
        }
      },
      resolve: {
        ctrl: ["$q", "$ocLazyLoad", ($q, $ocLazyLoad)=> {
          return $q((resolve)=> {
            require.ensure([], ()=> {
              let module = require("./index.js");
              $ocLazyLoad.load({name: module.default});
              resolve();
            });
          });
        }]
      }
    })
    .state("roles", {
      parent: "app",
      url: "/roles?rolename",
      feature: "menu.settings.roles",
      executeUserCheck: function canReadUsers(user) {
        return user.effectiveUserObjectPermissions && user.effectiveUserObjectPermissions.userObjectsRead;
      },
      views: {
        "main": {
          template: require("./eaRolePage/eaRolePageModule.html"),
          controller: "eaRolePageModuleController as $ctrl"
        }
      },
      resolve: {
        ctrl: ["$q", "$ocLazyLoad", ($q, $ocLazyLoad)=> {
          return $q((resolve)=> {
            require.ensure([], ()=> {
              let module = require("./index.js");
              $ocLazyLoad.load({name: module.default});
              resolve();
            });
          });
        }],
        companyFilterEnabled: ["UserService", (UserService) => {
          return UserService.hasFeature("settingsUserListPage.companyFilterEnabled");
        }]
      }
    });
}];


// WEBPACK FOOTER //
// ./src/ui/modules/eaSettings/eaRole/routes.js